import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "toast-icon" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { key: 2 };
const _hoisted_5 = { key: 3 };
const _hoisted_6 = { class: "toast-content" };
const _hoisted_7 = {
    key: 0,
    class: "toast-title"
};
const _hoisted_8 = { class: "toast-message" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'ToastItem',
    props: {
        notification: {}
    },
    emits: ["close"],
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["toast-item", [`type-${__props.notification.type}`]]),
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close')))
            }, [
                _createElementVNode("div", _hoisted_1, [
                    (__props.notification.type === 'success')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "✨"))
                        : (__props.notification.type === 'warning')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "⚠️"))
                            : (__props.notification.type === 'error')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "🔥"))
                                : (_openBlock(), _createElementBlock("span", _hoisted_5, "📜"))
                ]),
                _createElementVNode("div", _hoisted_6, [
                    (__props.notification.title)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(__props.notification.title), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(__props.notification.message), 1 /* TEXT */)
                ]),
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "toast-close" }, "×", -1 /* CACHED */)),
                _createCommentVNode(" 进度条（仅当有自动关闭时显示） "),
                ((__props.notification.duration || 0) > 0)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "toast-progress",
                        style: _normalizeStyle({ animationDuration: `${__props.notification.duration}ms` })
                    }, null, 4 /* STYLE */))
                    : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */));
        };
    }
});
